export const saveBeverageV5ConsentOnly = async ({
  acid,
  optedOut,
  actionWebInvoke,
  actionUrl,
  storage = sessionStorage,
  logger = console,
  shouldPersist = () => true,
}) => {
  if (!acid) {
    return false;
  }

  try {
    await actionWebInvoke(
      actionUrl,
      {},
      {
        acid,
        optedOutPersonalization: optedOut,
      },
    );

    if (!shouldPersist()) {
      return false;
    }

    storage.setItem("beverageConsentResponded", "true");
    storage.setItem("beverageConsentOptedOut", String(optedOut));
    return true;
  } catch (error) {
    logger.error("Error saving consent:", error);
    return false;
  }
};
